import { Icon } from '@iwoca/orion';
import { IconNames } from '@iwoca/orion/lib/components/icon/Icon';
import clsx from 'clsx';
import BankIcon from 'svg/BankIcon';
import BuildingIcon from 'svg/BuildingIcon';
import styles from './FeatureHighlight.module.css';

/**
 * TODO: Delete 'bank' and 'building2' from the prop types, render and their components
 * when the those icons are added to orion and we migrate to the latest version
 */

type TProps = {
  icon: IconNames | 'bank' | 'building2';
  feature: string;
  description?: string;
  className?: string;
};

export const FeatureHighlight = ({
  icon,
  feature,
  description,
  className,
}: TProps) => {
  let IconComponent;

  if (icon === 'bank') {
    IconComponent = <BankIcon />;
  } else if (icon === 'building2') {
    IconComponent = <BuildingIcon />;
  } else {
    IconComponent = <Icon fontSize="20px" icon={icon} />;
  }

  return (
    <div className={clsx(styles.featureHighlight, className)}>
      <div className={styles.iconWrapper}>{IconComponent}</div>
      <span>
        <span className={styles.feature}>{feature}</span>
        {description && (
          <span className={styles.description}> ({description})</span>
        )}
      </span>
    </div>
  );
};
